import { render } from "./UserProfileDropdown.vue?vue&type=template&id=0ece0075"
import script from "./UserProfileDropdown.vue?vue&type=script&lang=js"
export * from "./UserProfileDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__